import { useIntl } from 'react-intl'
import { LocalizedMessagesKey } from '../../components'

export const useLocalizedMessages = (
  localizedMessagesKey: LocalizedMessagesKey
) => {
  const { messages } = useIntl()

  return messages[localizedMessagesKey]
}
